module.exports = __webpack_public_path__ + "static/img/noGoods.d4c9df30.svg";